/* eslint-disable react/prop-types */
import { Checkbox, FormControlLabel } from "@mui/material";
import Grid from "@mui/material/Grid";
import SoftButton from "components/SoftButton";
import React from "react";

export default function TableHeadItems({ filterInfo, handleFilterChange, onFilterClick, onClearFilterClick }) {

    return (
        <Grid container gap={2} mb={2}>
            <Grid item xs={12} md={6} pl={3} lg={4}>
                <section style={{ display: "flex", flexDirection: "row", columnGap: 30 }}>
                    <FormControlLabel control={<Checkbox defaultChecked={true} checked={filterInfo?.all} name="all" onChange={handleFilterChange}
                    />} label={<p style={{ fontSize: 12 }}>همه</p>} />
                    <FormControlLabel control={<Checkbox checked={filterInfo?.needToApprove} name="needToApprove" onChange={handleFilterChange}
                    />} label={<p style={{ fontSize: 12 }}>نیاز به تایید</p>} />
                    <FormControlLabel control={<Checkbox checked={filterInfo?.hasDone} name="hasDone" onChange={handleFilterChange}
                    />} label={<p style={{ fontSize: 12 }}>اتمام</p>} />
                    <FormControlLabel control={<Checkbox checked={filterInfo?.hasApprove} name="hasApprove" onChange={handleFilterChange}
                    />} label={<p style={{ fontSize: 12 }}>تایید</p>} />
                </section>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
                <SoftButton onClick={onFilterClick} size="small" style={{ width: 100 }} variant="gradient" color="info">
                    فیلتر
                </SoftButton>
                <SoftButton
                    onClick={onClearFilterClick}
                    size="small"
                    style={{ marginRight: 10, width: 44 }}
                    variant="outlined"
                    color="error"
                >
                    حذف
                </SoftButton>
            </Grid>
        </Grid>
    )
}
